import Typography from '@components/v2/ui/Typography/Typography';
import { Box, Stack } from '@mui/material';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';
import BrandCard from './components/BrandCard';
import BrandTileSkeleton from './components/BrandTileSkeleton';
import SeeMoreCard from './components/SeeMoreCard';
import { useEnterBrandFromHome } from './hooks/useEnterBrandFromHome';
import { useStoreConnectionsRow } from './hooks/useStoreConnectionsRow';
import { StoreConnectionsTestIds } from './storeConnections.testIds';
import { BRAND_TILE_GAP } from './storeConnections.utils';

const StoreConnectionsSection = () => {
  const { translate } = useTranslation();
  const { enterBrandFromHome } = useEnterBrandFromHome();
  const { containerRef, slots, visibleBrands, hasTrailer, isLoading, isEmpty } =
    useStoreConnectionsRow();

  if (isEmpty) {
    return null;
  }

  return (
    <Box
      component="fieldset"
      test-id={StoreConnectionsTestIds.SECTION}
      sx={(theme) => ({
        m: 0,
        minWidth: 0,
        p: 1,
        border: `1px solid ${theme.palette.custom.border.primary}`,
        borderRadius: `${theme.shape.borderRadiusXl}px`,
      })}
    >
      <Typography component="legend" variant="body2" color="text.tertiary" sx={{ px: 1, ml: 3 }}>
        {translate(LangEnum.HOMEPAGE_ACCESS_BRANDS)}
      </Typography>
      <Stack
        ref={containerRef}
        direction="row"
        spacing={BRAND_TILE_GAP}
        useFlexGap
        sx={{ overflow: 'hidden' }}
      >
        {isLoading ? (
          Array.from({ length: slots }, (_, index) => (
            <BrandTileSkeleton key={`brand-tile-skeleton-${index}`} />
          ))
        ) : (
          <>
            {visibleBrands.map((brand) => (
              <BrandCard key={brand.id} brand={brand} onClick={enterBrandFromHome} />
            ))}
            {hasTrailer && <SeeMoreCard />}
          </>
        )}
      </Stack>
    </Box>
  );
};

export default StoreConnectionsSection;
